import { useState } from "react";
import Image from "next/image";
import { ExternalLink, Hotel } from "lucide-react";
import type { HotelPreview } from "@/lib/planner/activityTimeline";

function Photo({ url }: { url?: string }) {
  const [failed, setFailed] = useState(false);
  return (
    <span className="relative flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-md bg-muted">
      {url && !failed ? (
        <Image
          src={url}
          alt=""
          fill
          unoptimized
          sizes="80px"
          className="object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        <Hotel className="h-6 w-6 text-muted-foreground" aria-hidden="true" />
      )}
    </span>
  );
}

export default function HotelPreviewHeader({
  hotel,
  href,
}: {
  hotel: HotelPreview;
  href?: string;
}) {
  const content = (
    <>
      <Photo key={hotel.imageUrl} url={hotel.imageUrl} />
      <span className="min-w-0 text-sm font-semibold text-foreground">
        {hotel.name}
      </span>
      {href ? (
        <ExternalLink
          className="ml-auto h-4 w-4 shrink-0 text-muted-foreground"
          aria-hidden="true"
        />
      ) : null}
    </>
  );
  return href ? (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${hotel.name} (opens in a new tab)`}
      className="flex items-center gap-3 rounded-md hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      {content}
    </a>
  ) : (
    <div className="flex items-center gap-3">{content}</div>
  );
}
